import React, { Ref, AnchorHTMLAttributes } from 'react';
import { cx } from '@emotion/css';
import * as styles from './styles';
import useTheme from 'src/hooks/useTheme';

export type Props = AnchorHTMLAttributes<HTMLAnchorElement>;

const Tertiary: React.FC<Props & { innerRef: Ref<HTMLAnchorElement> }> = ({ className, innerRef, ...rest }) => {
  return <a className={cx(styles.main(useTheme()), className)} ref={innerRef} {...rest} />;
};

export default React.forwardRef<HTMLAnchorElement, Props>((props, ref) => {
  return <Tertiary innerRef={ref} {...props} />;
});
